import axios from "axios";
import React, { useEffect, useState } from "react";
import {
    base_url,
    currencycode,
    postHeader,
    user,
} from "../../Helpers/request";
import { whishlistlength } from "../../Reducer/wishlistReducer";
import { cartlengthvalue } from "../../Reducer/cartReducer";
import { sessionId } from "../../Reducer/homeReducer";
import { useDispatch, useSelector } from "react-redux";
import {
    useHistory,
    useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { Col, Container, Image, Row } from "react-bootstrap";
import { isDesktop } from "react-device-detect";
import TitleShape from "../../Assets/images/platinum/line-black.png";
import Slider from "react-slick";
import { Link } from "@material-ui/core";
import { Skeleton } from "@mui/material";

const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: false,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                initialSlide: 2,
                dots: true,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
            },
        },
    ],
};

const WatchCollection = () => {
    let { brand } = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
    const session_Id = useSelector(
        (state) => state.persistedReducer.home.session_id
    );
    const [loader, setLoader] = useState(true);
    const [collectionData, setCollectionData] = useState(null);

    const fetchWatchCollection = (brand) => {
        setLoader(true);
        const data = {
            currency_code: currencycode,
            //   sort_by: sortby,
            //   category: props.match.params.listcategory
            //     ? props.match.params.listcategory
            //     : "",
            //   search_text: props.match.params.search_text
            //     ? props.match.params.search_text
            //     : "",
            //   filterdata: addedfilter,
            //   limit: 18,
            //   offset: (page - 1) * 18,
            user_id: user.user_id ? user.user_id : "",
            session_id: session_Id,
            brand: brand,
        };
        axios
            .post(base_url + "/watch/brand_wise_collections", data, {
                headers: postHeader,
            })
            .then((res) => {
                if (res.data.status == 1) {
                    setLoader(false);
                    setCollectionData(res.data?.data);
                } else if (res.data.status == 2) {
                    localStorage.removeItem("bw-user");
                    dispatch(whishlistlength(0));
                    dispatch(cartlengthvalue(0));
                    dispatch(sessionId(""));
                    history.push("/");
                    window.location.reload(true);
                } else {
                    //   setListdata([]);
                    //   setProductCount(0);
                    //   setPageCount(0);
                    //   toast.error(res.message, { autoClose: 3000 });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    useEffect(() => {
        if (brand) {
            fetchWatchCollection(brand?.replaceAll("-", " "));
        }
    }, [brand]);

    return (
        <>
            <Container className="collection_container">
                <Row>
                    <Col sm={12} md={12} lg={12}>
                        <div className="sj_title_main">
                            <h2>
                                {brand.toUpperCase().replaceAll("-", " ")} WATCH COLLECTION
                            </h2>
                            <img src={TitleShape} alt="Heading Img" />
                        </div>
                    </Col>
                </Row>
                {
                    loader ? <Row>
                        {
                            Array.from({ length: isDesktop ? 12 : 1 }, (_, index) => index + 1)?.map((val) => (
                                <Col sm={12} md={6} lg={3}>
                                    <div className="collection_box" >
                                        <Skeleton height={isDesktop ? 285 : 380} />
                                    </div>
                                </Col>
                            ))
                        }
                    </Row> : <Row>
                        {isDesktop ? (
                            collectionData?.map((val) => (
                                <Col sm={12} md={6} lg={3}>
                                    <div className="collection_box" onClick={() => history.push(`/watches/${brand}/${val.collections}`)}>
                                        <Image src={val.imagelink} alt={val.collections} />
                                        <h4>{val.collections} </h4>
                                    </div>
                                </Col>
                            ))
                        ) : (
                            <Col sm={12} md={12} lg={12}>
                                <div className="collectionSlider">
                                    <Slider {...settings}>
                                        {collectionData?.map((val) => (
                                            <div className="collection_box" onClick={() => history.push(`/watches/${brand}/${val.collections}`)}>
                                                <Image src={val.imagelink} alt={val.collections} />
                                                <h4>{val.collections} </h4>
                                            </div>
                                        ))}
                                    </Slider>
                                </div>
                            </Col>
                        )}
                    </Row>
                }
            </Container>
        </>
    );
};

export default WatchCollection;
